import { Connector } from '@web3-react/types'
import INJECTED_ICON_URL from '../../assets/icons/logo.svg'
import METAMASK_ICON_URL from '../../assets/icons/metamask.svg'
import { ConnectionType, injectedConnection } from '../connection/connection'
import { getConnectionName } from '../connection/utils'

import Option from './Option'

const INJECTED_PROPS = {
    icon: INJECTED_ICON_URL,
    id: 'injected',
}

const METAMASK_PROPS = {
    icon: METAMASK_ICON_URL,
    id: 'metamask',
}

export const InstallMetaMaskOption = () => {
    return <Option {...METAMASK_PROPS} header="Install MetaMask" link={'https://metamask.io/'} />
}

export function OpenMetamaskWalletOption() {
    const isActive = injectedConnection.hooks.useIsActive()
    return (
        <Option
            {...METAMASK_PROPS}
            isActive={isActive}
            link="https://metamask.app.link/dapp/app.spritz.finance"
            header="Open in Metamask"
        />
    )
}

export const MetaMaskOption = ({
    tryActivation,
}: {
    tryActivation: (connector: Connector) => void
}) => {
    const isActive = injectedConnection.hooks.useIsActive()
    return (
        <Option
            {...METAMASK_PROPS}
            isActive={isActive}
            header={getConnectionName(ConnectionType.INJECTED, true)}
            onClick={() => tryActivation(injectedConnection.connector)}
        />
    )
}

export const InjectedOption = ({
    tryActivation,
}: {
    tryActivation: (connector: Connector) => void
}) => {
    const isActive = injectedConnection.hooks.useIsActive()
    return (
        <Option
            {...INJECTED_PROPS}
            isActive={isActive}
            header={getConnectionName(ConnectionType.INJECTED, false)}
            onClick={() => tryActivation(injectedConnection.connector)}
        />
    )
}
